import api from '../api/axiosInstance'; // asumimos que ya lo tenés configurado
export const listarEventos = () => api.get('/evento/listar-eventos');
export const listarEventosPorFecha = (fecha) => api.get('/evento/listar-en-fecha', { params: { fecha } });
export const crearEvento = (evento) => api.post('/evento/crear-evento', evento);
export const cancelarEvento = (id) => api.post('/evento/marcar-borrado', null, { params: { id } });
export const deshacerCancelacion = (id) => api.post('/evento/deshacer-cambio', null, { params: { id } });
export const listarEventosPorRango = (fechaDesde, fechaHasta) => {
    return api.get('/evento/listar-eventos-por-rango', {
        params: { fechaDesde, fechaHasta },
    });
};